module.exports = __webpack_public_path__ + "img/pointer.7b58746d.svg";